const DebtTypes = {
  ENROLED: 'eligibleDebts',
  PROGRAM_ENROLED: 'programEligibleDebts'
}

export { DebtTypes }
